import React from "react";

export default ({ submit, inputs, valueState, handleOptionChange }) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        marginLeft: "250px",
        paddingBottom: "100px",
      }}
    >
      <div
        className="container"
        style={{
          paddingLeft: "35px",
          paddingRight: "35px",
          paddingTop: "20px",
        }}
      >
        <h1 className="font-weight-bold">Add Product</h1>
        <div className="col">
          <form
            onSubmit={(e) => submit(e)}
            style={{
              padding: "40px",
              marginRight: "20px",
            }}
          >
            <div className="form-group">
              <h3 className="font-weight-bold">Names</h3>
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="name"
                type="text"
                className="form-control"
                placeholder="Product name..."
                required
                value={valueState.name}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇪🇸 - Spanish Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="nameSpanish"
                type="text"
                className="form-control"
                placeholder="Product name..."
                value={valueState.nameSpanish}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇺🇸 - English Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="nameEnglish"
                type="text"
                className="form-control"
                placeholder="Product name..."
                value={valueState.nameEnglish}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇧🇷 - Portuguese Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="namePortuguese"
                type="text"
                className="form-control"
                placeholder="Product name..."
                value={valueState.namePortuguese}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇫🇷 - French Name
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="nameFrench"
                type="text"
                className="form-control"
                placeholder="Product name..."
                value={valueState.nameFrench}
              />
            </div>

            <div className="form-group">
              <h3
                style={{
                  marginTop: "30px",
                }}
                className="font-weight-bold"
              >
                Descriptions
              </h3>
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Description
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="description"
                type="text"
                className="form-control"
                placeholder="Brief description of product..."
                value={valueState.description}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇪🇸 - Spanish Description
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="descriptionSpanish"
                type="text"
                className="form-control"
                placeholder="Brief description of product..."
                value={valueState.descriptionSpanish}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇺🇸 - English Description
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="descriptionEnglish"
                type="text"
                className="form-control"
                placeholder="Brief description of product..."
                value={valueState.descriptionEnglish}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇧🇷 - Portuguese Description
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="descriptionPortuguese"
                type="text"
                className="form-control"
                placeholder="Brief description of product..."
                value={valueState.descriptionPortuguese}
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                🇫🇷 - French Description
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="descriptionFrench"
                type="text"
                className="form-control"
                placeholder="Brief description of product..."
                value={valueState.descriptionFrench}
              />
            </div>
            <div className="form-group">
              <h3
                style={{
                  marginTop: "30px",
                }}
                className="font-weight-bold"
              >
                Details
              </h3>
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Image URL
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="imageProduct"
                type="text"
                className="form-control"
                placeholder="https://..."
              />

              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Order Number
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="orderProduct"
                type="text"
                className="form-control"
                placeholder="1, 2, 3..."
              />
            </div>
            <div className="form-group">
              <label
                style={{
                  marginTop: "20px",
                }}
              >
                Price
              </label>
              <input
                onChange={(e) => inputs(e)}
                name="price"
                type="text"
                className="form-control"
                placeholder="$..."
              />
            </div>

            <div
              class="form-group form-check"
              style={{
                marginTop: "20px",
              }}
            >
              <input
                onChange={(e) => handleOptionChange(e)}
                type="checkbox"
                class="form-check-input"
                id="check1"
                name="glutenFree"
                checked={valueState.glutenFree}
              />
              <label class="form-check-label" for="check1">
                🥖 Gluten Free
              </label>
            </div>

            <div
              class="form-group form-check"
              style={{
                marginTop: "20px",
              }}
            >
              <input
                onChange={(e) => handleOptionChange(e)}
                type="checkbox"
                class="form-check-input"
                id="check2"
                name="vegetarian"
                checked={valueState.vegetarian}
              />
              <label class="form-check-label" for="check2">
                🥗 Vegetarian
              </label>
            </div>

            <div
              class="form-group form-check"
              style={{
                marginTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <input
                onChange={(e) => handleOptionChange(e)}
                type="checkbox"
                class="form-check-input"
                id="check3"
                name="favourite"
                checked={valueState.favourite}
              />
              <label class="form-check-label" for="check3">
                ⭐️ Favourite
              </label>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{
                backgroundColor: "#FF2068",
                borderColor: "#FF2068",
              }}
            >
              Create
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
